import KkwindLanding from './KKWindSolutionsModule';

export default KkwindLanding;
